var render = function render(){var _vm=this,_c=_vm._self._c;return _c('colored-letter-square',{attrs:{"name":_vm.data.name,"length":2,"color":_vm.color}})
}
var staticRenderFns = []

export { render, staticRenderFns }